// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"b6ff6d24","419":"d7fe460b","439":"406d29f4","459":"ce977cd6","505":"da6bd84f","774":"701eaaaf","858":"e90b397d","968":"099761c9"}[chunkId] + ".chunk.js";
};